var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.9,
    y: 91.23,
    width: 141.96,
    height: 173.7,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.5,
    y1: 241.14,
    x2: 155.27,
    y2: 241.14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.43,185.24s5.4-2.16,10.95-1.19c5.54,.98,8.44,3.56,8.44,3.56l-14.19,5.82-5.19-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.28,197.11v10.94c0,1.06,.86,1.92,1.92,1.92h65.43s10.05,.46,31.18-4.71c8.15-1.99,15.21-5.22,17.22-7.8,0,0,.97-7.45-5.67-11.07l-12.32,3.4-41.55,3.08-44.97,2.57-9.27-.25c-1.08-.03-1.97,.84-1.97,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.17,148.51s-4.03-6.05-6.22-6.03-5.32,4.78-6.26,7.89l12.49-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.98,149.8c-.99-.06-1.72,.9-1.39,1.83,.63,1.82,1.48,4.5,1.66,6.39,.3,3.11,.48,7.66-1.44,12.51-1.91,4.85-5.33,20.16-3.95,24.65,0,0,59.55,.44,64.9,.17,5.35-.27,26.75-3.16,31.29-5.56,0,0-1.93-4.97-13.85-7.65-11.93-2.67-18.08-3.98-24.71-10.13-6.3-5.85-14.92-15.97-18.72-23.87-.34-.71-1.14-1.09-1.91-.93-4.26,.9-17.95,3.45-31.87,2.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 104.1,
    y1: 156.1,
    x2: 111.5,
    y2: 152.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.1,157.57c-.56,0-1.1-.32-1.34-.87-.33-.74,0-1.61,.74-1.95l7.41-3.33c.74-.34,1.61,0,1.95,.74,.33,.74,0,1.61-.74,1.95l-7.41,3.33c-.2,.09-.4,.13-.6,.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.79,
    y1: 169.39,
    x2: 120.34,
    y2: 164.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.79,170.87c-.45,0-.9-.21-1.19-.6-.48-.66-.34-1.58,.32-2.06l6.55-4.8c.66-.48,1.58-.34,2.06,.32,.48,.66,.34,1.58-.32,2.06l-6.55,4.8c-.26,.19-.57,.28-.87,.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.8,
    y1: 187.01,
    x2: 147.16,
    y2: 180.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.8,188.48c-.27,0-.54-.07-.79-.23-.69-.44-.89-1.35-.45-2.03l4.36-6.85c.44-.69,1.35-.89,2.03-.45,.69,.44,.89,1.35,.45,2.03l-4.36,6.85c-.28,.44-.76,.68-1.24,.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.82,
    y1: 180.13,
    x2: 131.56,
    y2: 174.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.82,181.6c-.38,0-.75-.14-1.04-.43-.58-.57-.58-1.51,0-2.08l5.74-5.74c.58-.58,1.51-.58,2.08,0,.58,.57,.58,1.51,0,2.08l-5.74,5.74c-.29,.29-.66,.43-1.04,.43Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 74.35,
    y: 68.78,
    width: 141.96,
    height: 173.7,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 112.94,
    y1: 218.69,
    x2: 177.72,
    y2: 218.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.87,162.8s5.4-2.16,10.95-1.19c5.54,.98,8.44,3.56,8.44,3.56l-14.19,5.82-5.19-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.73,174.66v10.94c0,1.06,.86,1.92,1.92,1.92h65.43s10.05,.46,31.18-4.71c8.15-1.99,15.21-5.22,17.22-7.8,0,0,.97-7.45-5.67-11.07l-12.32,3.4-41.55,3.08-44.97,2.57-9.27-.25c-1.08-.03-1.97,.84-1.97,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.62,126.06s-4.03-6.05-6.22-6.03-5.32,4.78-6.26,7.89l12.49-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.43,127.35c-.99-.06-1.72,.9-1.39,1.83,.63,1.82,1.48,4.5,1.66,6.39,.3,3.11,.48,7.66-1.44,12.51-1.91,4.85-5.33,20.16-3.95,24.65,0,0,59.55,.44,64.9,.17s26.75-3.16,31.29-5.56c0,0-1.93-4.97-13.85-7.65-11.93-2.67-18.08-3.98-24.71-10.13-6.3-5.85-14.92-15.97-18.72-23.87-.34-.71-1.14-1.09-1.91-.93-4.26,.9-17.95,3.45-31.87,2.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 112.79,
    cy: 145.98,
    r: 10.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,149.24l-1.79,.64c-.46,.16-.94-.18-.92-.67l.05-1.9c0-.16-.05-.31-.14-.44l-1.16-1.51c-.3-.38-.11-.95,.35-1.08l1.82-.54c.15-.04,.28-.14,.37-.27l1.07-1.57c.27-.4,.87-.4,1.14,0l1.07,1.57c.09,.13,.22,.23,.37,.27l1.82,.54c.47,.14,.65,.7,.35,1.08l-1.16,1.51c-.1,.13-.15,.28-.14,.44l.05,1.9c.01,.49-.46,.83-.92,.67l-1.79-.64c-.15-.05-.31-.05-.46,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.54,
    y1: 133.65,
    x2: 133.95,
    y2: 130.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.55,135.12c-.56,0-1.1-.32-1.34-.87-.33-.74,0-1.61,.74-1.95l7.41-3.33c.74-.34,1.61,0,1.95,.74,.33,.74,0,1.61-.74,1.95l-7.41,3.33c-.2,.09-.4,.13-.6,.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 136.24,
    y1: 146.94,
    x2: 142.79,
    y2: 142.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.24,148.42c-.45,0-.9-.21-1.19-.6-.48-.66-.34-1.58,.32-2.06l6.55-4.8c.66-.48,1.58-.34,2.06,.32,.48,.66,.34,1.58-.32,2.06l-6.55,4.8c-.26,.19-.57,.28-.87,.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 165.25,
    y1: 164.56,
    x2: 169.6,
    y2: 157.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.25,166.03c-.27,0-.54-.07-.79-.23-.69-.44-.89-1.35-.45-2.03l4.36-6.85c.44-.69,1.35-.89,2.03-.45,.69,.44,.89,1.35,.45,2.03l-4.36,6.85c-.28,.44-.76,.68-1.24,.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.27,
    y1: 157.68,
    x2: 154.01,
    y2: 151.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.27,159.15c-.38,0-.75-.14-1.04-.43-.58-.57-.58-1.51,0-2.08l5.74-5.74c.58-.58,1.51-.58,2.08,0,.58,.57,.58,1.51,0,2.08l-5.74,5.74c-.29,.29-.66,.43-1.04,.43Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 96.8,
    y: 46.33,
    width: 141.96,
    height: 173.7,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.83,87.91c-1.12-3.95-4.18-7.06-8.12-8.24l-15.23-4.55c-.18,.95-.58,1.86-1.21,2.66l-.6,.77-.73,.93-4.68,5.96c-1.2,1.53-3.23,2.13-5.07,1.52l-5.12-1.72v15.83c0,.88-.71,1.59-1.59,1.59h-5.38c-.88,0-1.59-.71-1.59-1.59v-15.83l3.06-1.03h0l-8.18,2.74c-1.84,.62-3.87,.01-5.07-1.52l-6.02-7.66c-.63-.8-1.03-1.72-1.21-2.67l-15.24,4.55c-3.94,1.18-7,4.28-8.12,8.24l-7.66,27.08,14.29,4.79,.58,.19h0l2.9,.97v7.48h0v41.72h69.89v-49.2l9.66-3.24h0l.88-.3,7.23-2.42-7.66-27.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.56 84.22 166.56 84.22 167.79 83.81 166.56 84.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.33,70.41h-27.92l.06,.12c.29,.55,.68,1.06,1.16,1.49l13.16,11.79h0l9.13-8.18,.42-.37,3.62-3.24c.39-.35,.72-.76,.99-1.19l.23-.41h-.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.61,
    y: 170.15,
    width: 1.16,
    height: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.77,170.15h-62.93v2.65c0,2.63,2.13,4.76,4.76,4.76h60.36c2.63,0,4.76-2.13,4.76-4.76v-2.65h-6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.94,119.98l-.58-.19h0l-14.29-4.79-.47,1.66c-.82,2.9,.78,5.93,3.64,6.89l11.12,3.73,3.48,1.17h0v-7.49l-2.9-.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.38,
    y: 117.71,
    width: 0,
    height: 0,
    transform: "translate(-30.22 107.41) rotate(-26.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.36,
    y: 117.56,
    width: 0.93,
    height: 0,
    transform: "translate(-18.92 44.02) rotate(-11.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.96,116.65l-.47-1.66-7.23,2.42h0l-.88,.3h0l-9.66,3.24v7.49l9.27-3.11h0l5.33-1.79c2.86-.96,4.46-3.99,3.64-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.18,62.41h-22.79c-1.27,0-2.49,.35-3.55,.99v4.62c0,.84,.21,1.66,.57,2.4h28.74c.37-.74,.57-1.56,.57-2.4v-4.62h0c-1.06-.64-2.28-.99-3.55-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.63,72.01c-.48-.43-.86-.93-1.16-1.49h0s-.04-.08-.06-.12c-.37-.74-.57-1.55-.57-2.4h0v-4.62c-.8,.48-1.51,1.12-2.06,1.9l-1.87,2.62-1.77,2.48c-1,1.4-1.34,3.11-1.04,4.72,.18,.95,.58,1.87,1.21,2.67l6.02,7.66c1.2,1.53,3.23,2.13,5.07,1.52l8.18-2.74,1.22-.41-13.16-11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.01,84.22l-1.22-.41h0l-1.22,.41-3.06,1.03v15.83c0,.88,.71,1.59,1.59,1.59h5.38c.88,0,1.59-.71,1.59-1.59v-15.83l-3.06-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.44,70.4l-1.77-2.48-1.87-2.62c-.56-.78-1.26-1.42-2.06-1.9h0v4.62c0,.84-.2,1.66-.57,2.4l-.23,.41c-.27,.44-.6,.84-.99,1.19l-3.62,3.24-.42,.37-9.13,8.18,1.22,.41h0l3.06,1.03,5.12,1.72c1.84,.62,3.87,.01,5.07-1.52l4.68-5.96,.73-.93,.6-.77c.63-.8,1.03-1.71,1.21-2.66,.3-1.61-.04-3.32-1.04-4.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.4,
    y: 83.37,
    width: 0,
    height: 1.29,
    transform: "translate(35.19 216.95) rotate(-71.45)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 135.39,
    y1: 196.24,
    x2: 200.17,
    y2: 196.24
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 162.24,
    y: 26,
    width: 76.52,
    height: 40.67,
    rx: 20.33,
    ry: 20.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 186.43,
    y1: 37.01,
    x2: 186.43,
    y2: 55.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 177.11,
    y1: 46.33,
    x2: 195.75,
    y2: 46.33
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 214.57,
    y1: 37.01,
    x2: 214.57,
    y2: 55.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 205.25,
    y1: 46.33,
    x2: 223.9,
    y2: 46.33
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus1);
export default __webpack_public_path__ + "static/media/whyus1.c60df68ee64f1e8442e0160270020c1c.svg";
export { ForwardRef as ReactComponent };